import { FC, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Link, Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

import { getDuplicationLocation } from './service';
import { DuplicateAccountLocation } from './types';

export const DuplicateLocationModal: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { watch, formState } = useFormContext();
  const [duplicateLocations, setDuplicateLocations] = useState<DuplicateAccountLocation[]>([]);

  const [name] = watch(['name']);

  const requestDuplicateLocation = async (fields, signal) => {
    const response = await getDuplicationLocation(fields, signal);

    if (response?.type === 'success') {
      const filterCurrentLocation = response.data.accountLocations;

      if (filterCurrentLocation.length) {
        setIsOpen(true);
        setDuplicateLocations(response.data.accountLocations);
      }
    }
  };

  useEffect(() => {
    const abortController: AbortController = new AbortController();

    const timeout = setTimeout(() => {
      if (!formState.isDirty || [name].some((value) => !value)) {
        return;
      }
      requestDuplicateLocation({ name }, abortController.signal);
    }, 1500);

    return () => {
      timeout && clearTimeout(timeout);
      abortController.abort();
    };
  }, [name, formState.isDirty]);

  return (
    <Modal open={isOpen} maxWidth="md" data-testid="duplicate-location-modal">
      <Modal.Title>Duplicate location</Modal.Title>
      <Modal.Content>
        <Text mb="10px">
          Account locations cannot have the same Name. Please change the Name so it accurately describes when it should
          be used for the Rider or the Rider Category.
        </Text>
        <Box display="flex" flexDirection="column" gap={1}>
          {duplicateLocations.map((location) => (
            <Link key={location.id} href={`/locations/${location.id}/edit`} target="_blank" rel="noreferrer">
              <>
                {location.name} {location.address}
              </>
            </Link>
          ))}
        </Box>
      </Modal.Content>
      <Modal.Actions>
        <Button color="primary" onClick={() => setIsOpen(false)}>
          Continue with New Location
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
